import React from 'react';
import { Layout, CheckForApplicationUpdate } from 'react-admin';
import { CustomMenu } from './CustomMenu';
import { AppLocationContext } from '@react-admin/ra-navigation';

// export const CustomLayout = (props: any) => (
//     <AppLocationContext>
//         <LayoutWrapper>
//             <Layout
//                 {...props}
//                 menu={CustomMenu}
//             />
//         </LayoutWrapper>
//     </AppLocationContext>

// ); 

export const CustomLayout = ({ children }: { children: React.ReactNode }) => (
    <AppLocationContext>
      {/* <Layout menu={Menu}> */}
      <Layout 
        menu={CustomMenu}
        // sx={{
        //   '& .RaLayout-content': {
        //     overflowX: 'hidden',
        //     overflowY: 'auto',
        //     maxWidth: '100vw',
        //     height: '100vh',
        //   },
        //   '& .RaList-main': {
        //     overflowX: 'hidden',
        //     overflowY: 'visible',
        //   },
        //   '& .RaList-content': {
        //     overflowX: 'hidden',
        //     overflowY: 'visible',
        //   }
        // }}
      >
          {children}
          <CheckForApplicationUpdate interval={10 * 60 * 1000} />
      </Layout>
    </AppLocationContext>
  );